import styled from 'styled-components'

import { media } from 'shared/lib'
import { ArticleVideo } from 'shared/types/ArticleVideo'
import { useEffect, useState } from 'react'

type ArticleVideoSectionProps = {
  section: ArticleVideo
}

const transformToEmbedUrl = (url: string) => {
  const embedUrlPrefix = 'https://www.youtube.com/embed/'
  if (url && url.includes(embedUrlPrefix)) {
    return url
  }

  const regExp = /^.*(youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|&v=)([^#&?]*).*/
  const match = url.match(regExp)

  return match && match?.[2]?.length === 11 ? `${embedUrlPrefix}${match[2]}` : null
}

export const ArticleVideoSection = ({ section }: ArticleVideoSectionProps) => {
  const [iFrameHeight, setIFrameHeight] = useState(0)
  const srcUrl = transformToEmbedUrl(section?.embeddedVideoUrl)

  useEffect(() => {
    // iFrame height being set to 150px by default resulting in cropping. Dynamically calculate height of video
    const getIFrameHeight = () => {
      const aspectRatio = 63 / 112
      const width = document.getElementById('article-video-iframe')?.offsetWidth || 0
      setIFrameHeight(Math.ceil(aspectRatio * width))
    }

    if (typeof window !== 'undefined') {
      getIFrameHeight()

      window.addEventListener('resize', getIFrameHeight)
      return () => window.removeEventListener('resize', getIFrameHeight)
    }
  }, [])

  if (!srcUrl) {
    return null
  }

  return (
    <Container>
      <CustomIFrame
        $height={iFrameHeight}
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
        allowFullScreen
        data-qa="ArticleVideo"
        frameBorder="0"
        id="article-video-iframe"
        referrerPolicy="strict-origin-when-cross-origin"
        src={transformToEmbedUrl(section?.embeddedVideoUrl)}
        title={section?.title}
      />
    </Container>
  )
}

const Container = styled.div`
  align-items: center;
  display: flex;
  flex-direction: column;
  justify-content: center;
  margin-bottom: 120px;
  margin-top: 120px;
  padding-left: 24px;
  padding-right: 24px;
  width: 100vw;

  ${media.medium`
    margin-bottom: 240px;
    margin-top: 240px;
    padding-left: 156px;
    padding-right: 156px;
  `}
`
const CustomIFrame = styled.iframe<{ $height: number }>`
  height: ${({ $height }) => ($height ? `${$height}px` : '100vh')};
  max-width: 1200px;
  width: 100%;
`
